import { gql } from '@apollo/client';

export const CREATE_PRACTICE_TEST = gql`
  mutation CreatePracticeTestSession {
    createPracticeTestSession {
      testSession {
        id
        practiceTestStatus
        recruitParticipantToken {
          id
          token
        }
        tester {
          id
          project {
            id
            segments {
              participantsLanguage
              device
            }
          }
          user {
            id
            tester
          }
        }
      }
    }
  }
`;
